import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('registry-offices', storeModule.createStoreModule('registry-offices'))
